import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import Switch from 'react-switch';
import { FlexBetween } from '../../styles/stylesStyled';
import { Box, NotificationSubtitle, NotificationTitle } from './SettingsStyled';

import { PageTitle } from '../../styles/GlobalComponents';
import { color } from '../../styles/GlobalStyles';
import { setNotification } from './Settings.actions';
import { useAppSelector } from '../../app/hooks';
import { CaptionText, H3, H4, P1, P2, P3 } from '../../styles/FontStyles';

export const NotificationsSettings = () => {
  const dispatch = useDispatch();
  const { notifications } = useAppSelector((state) => state.settings);

  const { t } = useTranslation('settings');

  const newNotifications = [
    {
      id: 1,
      title: t('notifications.earnings.title'),
      subtitle: t('notifications.earnings.subtitle')
    },
    {
      id: 2,
      title: t('notifications.news.title'),
      subtitle: t('notifications.news.subtitle')
    },
    {
      id: 3,
      title: t('notifications.promotions.title'),
      subtitle: t('notifications.promotions.subtitle')
    },
    {
      id: 4,
      title: t('notifications.referral.title'),
      subtitle: t('notifications.referral.subtitle')
    }
  ];

  return (
    <>
      {notifications?.map((item: any, index: number) => {
        return (
          <Box key={index}>
            <FlexBetween>
              <div>
                <H4 bold mb='4'>
                  {item.id === newNotifications[index].id &&
                    newNotifications[index].title}
                </H4>
                <P2 color={color.colors.neutral900}>
                  {item.id === newNotifications[index].id &&
                    newNotifications[index].subtitle}
                </P2>
              </div>
              <Switch
                onChange={() => dispatch(setNotification(item))}
                checked={item.checked}
                checkedIcon={false}
                uncheckedIcon={false}
                onColor={color.colors.secondary100}
              />
            </FlexBetween>
          </Box>
        );
      })}
    </>
  );
};
